import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import ProducerSidebar from '../Dashboard/components/ProducerSidebar';
import Header from '../../../components/layout/Header/Header';
import { C, ff } from '../../../shared/constants/dashboardConstants';
import { useAuth } from '../../../contexts/AuthContext';
import { getMyProducerProfile } from '../../../api/producerApi';
import { getDefaultProfileImage } from '../../../shared/utils/profilePlaceholders';
import { isProducerLogoRemoved } from '../Company/ProducerCompanyPage';
import PostLoginNoticeModal, { clearPostLoginNoticePending, hidePostLoginNoticeToday, shouldShowPostLoginNotice } from '../../../shared/components/PostLoginNoticeModal';

export default function ProducerLayout() {
  const { setUserInfo } = useAuth();
  const [showPostLoginNotice, setShowPostLoginNotice] = useState(() => shouldShowPostLoginNotice());
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const override = (() => {
      try {
        const raw = localStorage.getItem('producerIdentityOverride');
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    })();

    if (override?.name || override?.profileImage) {
      setUserInfo({
        name: override.name || '',
        profileImage: override.profileImage || getDefaultProfileImage('PRODUCER'),
      });
    }

    getMyProducerProfile().then(p => {
      const logoRemoved = isProducerLogoRemoved();
      const nextName = override?.name || p.companyName || p.name || '';
      const nextImage = logoRemoved
        ? getDefaultProfileImage('PRODUCER')
        : (override?.profileImage || p.logoUrl || p.profileImage || p.imageUrl || getDefaultProfileImage('PRODUCER'));
      setUserInfo({
        name: nextName,
        profileImage: nextImage,
      });
    }).catch(() => {});
  }, [setUserInfo]);

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: ff }}>
      {showPostLoginNotice && (
        <PostLoginNoticeModal
          onClose={() => {
            clearPostLoginNoticePending();
            setShowPostLoginNotice(false);
          }}
          onHideToday={() => {
            hidePostLoginNoticeToday();
            setShowPostLoginNotice(false);
          }}
        />
      )}
      <Header isSidebarPage onMenuClick={() => setSidebarOpen(o => !o)} />
      <ProducerSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div style={{ marginLeft: 'clamp(240px, 25vw, 342px)', paddingTop: '72px', minHeight: '100vh' }} className="producer-content">
        <Outlet />
      </div>
    </div>
  );
}
